export const SessionStorageConstants = {
    IntelligyStart: 'intelligy-start',
    IntelligyStartIsAuthorized: 'intelligy-start-is-authorized',
}